import React from 'react'
import PropTypes from 'prop-types'
import {formatMessageDate} from 'ag-common/tools/dates'
import Text from '#components/a/Text'
import {parseISO} from 'ag-common/facades'

function ChatMessage({userName, messageText, timestamp}) {
  return (
    <div className="chat-message-item">
      <div>
        <div className="chat-message--header">
          <span className="chat-message--header--name">{userName}</span>
          <span className="chat-message--header--timestamp">{formatMessageDate(parseISO(timestamp))}</span>
        </div>
        <Text text={messageText} />
      </div>
    </div>
  )
}

ChatMessage.propTypes = {
  userName: PropTypes.string.isRequired,
  messageText: PropTypes.string.isRequired,
  timestamp: PropTypes.string.isRequired,
}

export default ChatMessage
